<div class="download-block--gray">
    <div class="download-block--gray--details" [innerHTML]="downloadDescription | i18n"></div>
    <button
        type="button"
        id="download_btn"
        class="button button--noBackground"
        (click)="downloadFile()"
        data-tag-commander=""
        [appTagCommander]="'tagCo.documentselection-exp3.download.document.pij3001'"
        data-file-download-person-id="nextStepIntroduction.summaryExpectedMedicalDocuments.personId"
        data-file-download-proposition-id="nextStepIntroduction.summaryExpectedMedicalDocuments.propositionId"
        data-file-download-document-id="nextStepIntroduction.summaryExpectedMedicalDocuments.id"
        data-file-download-name="nextStepIntroduction.summaryExpectedMedicalDocuments.title"
        data-ng-model="nextStepIntroduction.summaryExpectedMedicalDocuments.downloaded"
    >
        <span data-ng-transclude="">
            <em class="icon icon--arrow-down-border-2"></em><span class="button-text">{{ 'documentselection.documents.button.text' | i18n }}</span>
        </span>
    </button>
</div>
